import axiosApiInstance from "../../../app/axios";
import { getJwtToken } from "../../../app/common";
import { PARKIT_API_BASE_URL } from "../../../app/utils";

const url = `${PARKIT_API_BASE_URL}/parkit/v2/cpms-connections`;
const auth = () => ({
  headers: { Authorization: `Bearer ${getJwtToken()}` },
});

export const getCpmsConnections = () => axiosApiInstance.get(url, auth());

export const createCpmsConnection = (connection) =>
  axiosApiInstance.post(url, connection, auth());

export const testCpmsConnection = (id) =>
  axiosApiInstance.post(`${url}/${id}/test`, {}, auth());

export const revokeCpmsConnection = (id) =>
  axiosApiInstance.post(`${url}/${id}/revoke`, {}, auth());

export const deleteCpmsConnection = (id) =>
  axiosApiInstance.delete(`${url}/${id}`, auth());

export const recoverCpmsObservationFeed = (connectionId, siteId, feed) =>
  axiosApiInstance.post(
    `${url}/${connectionId}/observation/${encodeURIComponent(siteId)}/${feed}/recover`,
    {},
    auth()
  );
